// nav-liter.js

document.addEventListener('DOMContentLoaded', () => {
  const submenuItems = document.querySelectorAll('.header__submenu .header__menu-item');

  submenuItems.forEach(item => {
    item.addEventListener('touchstart', () => {
      submenuItems.forEach(i => i.classList.remove('nav-hover-active'));
      item.classList.add('nav-hover-active');
    });
  });
});
